export default class myClass{
	constructor($scope,
				$routeParams,
				method,
				unidadEjecutoraService,
				$location,
                $uibModal,
                toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(unidadEjecutoraService);
			break;
			case 'new':
				this.create(unidadEjecutoraService);
			break;
			case 'view':
				this.view($routeParams,
						unidadEjecutoraService);
			break;
		}
	}

	list(unidadEjecutoraService){

        let self = this.scope;

		unidadEjecutoraService.getAll().then((resp, err) => {
			self.unidad_ejecutora = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.unidad_ejecutora.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, unidadEjecutoraService);

		/*
        this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                unidadEjecutoraService.delete({_id: id}).then((resp) => {
                    this.toastr.success('Unidad ejecutora eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al eliminar la unidad ejecutora!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};*/
	}

	create(unidadEjecutoraService){

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                unidadEjecutoraService.save(this.scope.unidad_ejecutora).then((resp) => {
                    this.toastr.success('Unidad ejecutora creada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/unidad_ejecutora');
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al crear la unidad ejecutora!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
	}

	view($routeParams,
		 unidadEjecutoraService){

		this.scope.aux = {};
		unidadEjecutoraService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.unidad_ejecutora = resp.data.message;
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                unidadEjecutoraService.update(this.scope.unidad_ejecutora).then((resp) => {
                    this.toastr.success('Unidad ejecutora modificada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/unidad_ejecutora');
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al modificar la unidad ejecutora!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Unidad Ejecutora</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la Unidad Ejecutora: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.unidad_ejecutora.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Unidad Ejecutora eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar la Unidad Ejecutora!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/unidadEjecutora/unidad_ejecutora.js